// extracted by mini-css-extract-plugin
export var header = "header-module--header--2ea3u";
export var brandContainer = "header-module--brand-container--2zz04";
export var brand = "header-module--brand--1lMzv";
export var logoText = "header-module--logo-text--T2bdz";
export var mainNav = "header-module--main-nav--1gjeh";
export var phoneHamburgerContainer = "header-module--phone-hamburger-container--9qiLp";
export var phoneNav = "header-module--phone-nav--1JIH0";
export var hamburgerButton = "header-module--hamburger-button--2__lA";